import type { MarkdownExtension } from "./parse";

interface PmcTableRendererProps {
  meta: Record<string, string>;
  body: string;
}

function PmcTableRenderer({ meta, body }: PmcTableRendererProps) {
  const { label, caption } = meta;
  return (
    <figure>
      {(label || caption) && (
        <figcaption>
          {label && <b>{label}</b>}
          {label && caption && " "}
          {caption}
        </figcaption>
      )}
      {/* Raw JATS HTML table — source is PMC, not user input. */}
      <div dangerouslySetInnerHTML={{ __html: body }} />
    </figure>
  );
}

export const pmcTableExtension: MarkdownExtension = {
  language: "pmc-table",
  Component: PmcTableRenderer,
};
